import React, { useState, useEffect, useRef, useCallback } from 'react';
import './BirthdayCelebration.css';

// 创始人生日数据 - 移到组件外部以便其他组件能够导入使用
const FOUNDERS = [
  { name: '张总', fullName: 'Ethan Zhang', birthday: '12-08', year: '2012' },
  { name: '丁总', fullName: 'PaiPai Ding', birthday: '05-15', year: '2013' },
  { name: '袁总', fullName: 'Roger Yuan', birthday: '06-30', year: '2013' },
  { name: '孙总', fullName: 'Nathan Sun', birthday: '12-26', year: '2012' }
];

// 检查今天是否是创始人生日
export function isTodayFounderBirthday() {
  const today = new Date();
  const currentMonth = String(today.getMonth() + 1).padStart(2, '0');
  const currentDay = String(today.getDate()).padStart(2, '0');
  const currentDate = `${currentMonth}-${currentDay}`;
  
  console.log("当前日期格式化后:", currentDate);
  console.log("所有创始人生日:", FOUNDERS.map(f => `${f.fullName}: ${f.birthday}`).join(", "));
  
  // 查找今天生日的创始人
  const birthdayFounder = FOUNDERS.find(founder => {
    const match = founder.birthday === currentDate;
    console.log(`比较 ${founder.fullName} 的生日 ${founder.birthday} 与今天 ${currentDate}: ${match}`);
    return match;
  });
  
  if (birthdayFounder) {
    console.log("找到今天过生日的创始人:", birthdayFounder.fullName);
  } else {
    console.log("今天不是任何创始人的生日");
  }
  
  return birthdayFounder ? { isToday: true, founder: birthdayFounder } : { isToday: false };
}

// 导出创始人列表，方便其他组件使用
export const FOUNDER_LIST = FOUNDERS;

const BirthdayCelebration = ({ forceCelebrate = false, founderName = '', shouldPersist = true, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [celebratingFounder, setCelebratingFounder] = useState('');
  const [hasWished, setHasWished] = useState(false);
  const [danmakus, setDanmakus] = useState([]);
  const [customMessage, setCustomMessage] = useState('');
  const [isGiftDropdownOpen, setIsGiftDropdownOpen] = useState(false);
  const [isPageVisible, setIsPageVisible] = useState(true);
  const [isSendingCooldown, setIsSendingCooldown] = useState(false);
  const [cooldownSeconds, setCooldownSeconds] = useState(5);
  
  // 存储已被占用的轨道信息
  const trackUsageRef = useRef({});
  // 存储弹幕计时器
  const danmakuIntervalRef = useRef(null);
  // 下拉框引用
  const dropdownRef = useRef(null);
  // 冷却计时器引用
  const cooldownTimerRef = useRef(null);
  
  // 礼物选项
  const giftOptions = [
    { value: 50, label: '50 个海龟币' },
    { value: 100, label: '100 个海龟币' },
    { value: 300, label: '300 个海龟币' },
    { value: 500, label: '500 个海龟币' },
    { value: 1000, label: '1000 个海龟币' },
  ];
  
  // 生成随机用户名
  const generateRandomName = () => {
    // 生成8位随机数字
    const randomNum = Math.floor(10000000 + Math.random() * 90000000);
    return `灌汤包${randomNum}`;
  };
  
  // 获取可用的弹幕轨道 - 增加轨道间距避免视觉堆叠
  const getAvailableTrack = () => {
    // 定义更少但更分散的轨道位置（百分比）
    const tracks = [12, 24, 36, 48, 60, 72];
    const currentTime = Date.now();
    const trackUsage = trackUsageRef.current;
    
    // 清理过期的轨道占用记录
    Object.keys(trackUsage).forEach(track => {
      if (currentTime - trackUsage[track] > 3000) { // 增加到3秒后释放轨道
        delete trackUsage[track];
      }
    });
    
    // 寻找可用轨道
    for (const track of tracks) {
      if (!trackUsage[track]) {
        trackUsage[track] = currentTime;
        return track;
      }
    }
    
    // 如果所有轨道都被占用，随机选择一个轨道
    const randomTrack = tracks[Math.floor(Math.random() * tracks.length)];
    trackUsage[randomTrack] = currentTime;
    return randomTrack;
  };
  
  // 创建新的系统弹幕 (由系统自动产生)
  const createSystemDanmaku = useCallback(() => {
    if (!isPageVisible) return;
    
    // 创建一个新的随机弹幕
    const id = Date.now() + Math.random();
    const name = generateRandomName();
    const position = getAvailableTrack();
    
    const newDanmaku = { 
      id, 
      name, 
      position, 
      isUser: false, 
      isCustom: false,
      giftAmount: null
    };
    
    // 添加到React状态
    setDanmakus(prev => [...prev, newDanmaku]);
    
    // 设置定时清除
    setTimeout(() => {
      setDanmakus(prev => prev.filter(d => d.id !== id));
    }, 8000);
  }, [isPageVisible]);
  
  // 创建用户弹幕 (由用户动作触发)
  const createUserDanmaku = useCallback((content, isCustom = false, giftAmount = null) => {
    if (!isPageVisible) return;
    
    const id = Date.now() + Math.random();
    const position = getAvailableTrack();
    
    const newDanmaku = { 
      id,
      name: content, 
      position, 
      isUser: true, 
      isCustom, 
      giftAmount 
    };
    
    setDanmakus(prev => [...prev, newDanmaku]);
    
    // 8秒后移除弹幕
    setTimeout(() => {
      setDanmakus(prev => prev.filter(d => d.id !== id));
    }, 8000);
  }, [isPageVisible]);
  
  // 启动弹幕系统 - 完全重写
  const startDanmakuSystem = useCallback(() => {
    // 确保先清理之前可能存在的计时器
    if (danmakuIntervalRef.current) {
      clearInterval(danmakuIntervalRef.current);
      danmakuIntervalRef.current = null;
    }
    
    // 清空轨道使用记录
    trackUsageRef.current = {};
    
    // 清空现有弹幕
    setDanmakus([]);
    
    if (isPageVisible) {
      // 改为只使用一种方式添加弹幕，确保严格1秒一条
      danmakuIntervalRef.current = setInterval(() => {
        createSystemDanmaku();
      }, 1000);
    }
  }, [createSystemDanmaku, isPageVisible]);
  
  // 停止弹幕系统
  const stopDanmakuSystem = useCallback(() => {
    if (danmakuIntervalRef.current) {
      clearInterval(danmakuIntervalRef.current);
      danmakuIntervalRef.current = null;
    }
  }, []);

  // 监听页面可见性变化
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // 页面变为可见时
        setIsPageVisible(true);
        
        // 清空现有弹幕
        setDanmakus([]);
        
        // 清空轨道使用记录
        trackUsageRef.current = {};
        
        // 重新启动弹幕系统
        setTimeout(() => {
          if (isVisible) {
            startDanmakuSystem();
          }
        }, 500);
      } else {
        // 页面变为不可见时
        setIsPageVisible(false);
        stopDanmakuSystem();
        
        // 清空弹幕和轨道记录
        setDanmakus([]);
        trackUsageRef.current = {};
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isVisible, startDanmakuSystem, stopDanmakuSystem]);

  // 初始化生日卡片
  useEffect(() => {
    console.log("BirthdayCelebration 初始化，forceCelebrate:", forceCelebrate, "founderName:", founderName);
    
    // 强制庆祝模式 - 主要用于测试，正常不应该使用
    if (forceCelebrate) {
      console.log("强制庆祝模式启动");
      const founder = founderName ? 
        FOUNDERS.find(f => f.name === founderName || f.fullName === founderName) || FOUNDERS[0] 
        : FOUNDERS[0];
      
      console.log("选择的创始人:", founder);
      setCelebratingFounder(founder);
      setIsVisible(true);
      
      // 添加类来禁止body滚动
      document.body.classList.add('birthday-active');
      
      // 启动弹幕系统
      startDanmakuSystem();
    } else {
      // 正常生产模式：使用公共函数检查今天是否是创始人生日
      console.log("正常模式，检查今天是否有创始人生日");
      const birthdayCheck = isTodayFounderBirthday();
      console.log("生日检查结果:", birthdayCheck);
      
      if (birthdayCheck.isToday) {
        console.log("今天是创始人生日:", birthdayCheck.founder.fullName);
        setCelebratingFounder(birthdayCheck.founder);
        setIsVisible(true);
        
        // 添加类来禁止body滚动
        document.body.classList.add('birthday-active');
        
        // 启动弹幕系统
        startDanmakuSystem();
      } else {
        // 今天不是创始人生日，确保组件不可见
        console.log("今天不是创始人生日，组件应该不可见");
        setIsVisible(false);
        setCelebratingFounder('');
        document.body.classList.remove('birthday-active');
      }
    }
  }, [forceCelebrate, founderName, startDanmakuSystem]);

  // 只有在组件真正卸载时才清理
  useEffect(() => {
    return () => {
      // 如果不是持久化模式，或者组件真正卸载时才清理
      if (!shouldPersist) {
        if (danmakuIntervalRef.current) {
          clearInterval(danmakuIntervalRef.current);
          danmakuIntervalRef.current = null;
        }
        
        // 清理冷却计时器
        if (cooldownTimerRef.current) {
          clearInterval(cooldownTimerRef.current);
          cooldownTimerRef.current = null;
        }
        
        // 清空弹幕
        setDanmakus([]);
        
        document.body.classList.remove('birthday-active');
      }
    };
  }, [shouldPersist]);

  // 用于处理点击下拉框外部关闭下拉框
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsGiftDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // 处理关闭按钮点击
  const handleClose = () => {
    setIsVisible(false);
    document.body.classList.remove('birthday-active');
    
    // 停止弹幕系统
    stopDanmakuSystem();
    
    // 调用父组件提供的onClose回调，通知关闭事件
    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };
  
  // 处理祝福按钮点击
  const handleWish = () => {
    setHasWished(true);
    
    // 用户点击祝福时，添加自己的弹幕
    createUserDanmaku('我');
  };

  // 处理礼物下拉菜单显示/隐藏
  const toggleGiftDropdown = () => {
    setIsGiftDropdownOpen(!isGiftDropdownOpen);
  };

  // 处理送礼物
  const handleSendGift = (amount) => {
    // 发送礼物弹幕
    createUserDanmaku('我', false, amount);
    // 关闭下拉菜单
    setIsGiftDropdownOpen(false);
  };

  // 处理发送自定义弹幕
  const handleSendCustomMessage = () => {
    if (customMessage.trim() && !isSendingCooldown) {
      // 发送自定义弹幕
      createUserDanmaku(customMessage.trim(), true);
      setCustomMessage(''); // 清空输入框
      
      // 设置冷却时间
      setIsSendingCooldown(true);
      setCooldownSeconds(5);
      
      // 设置倒计时，每秒更新一次
      cooldownTimerRef.current = setInterval(() => {
        setCooldownSeconds(prev => {
          if (prev <= 1) {
            clearInterval(cooldownTimerRef.current);
            cooldownTimerRef.current = null;
            setIsSendingCooldown(false);
            return 5;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  // 处理输入框按回车发送
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendCustomMessage();
    }
  };

  // 如果没有庆祝，不显示任何内容
  if (!isVisible) return null;

  // 获取当前日期
  const today = new Date();
  const currentYear = today.getFullYear();
  const formattedCurrentDate = `${currentYear}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  const birthYear = celebratingFounder.year;
  const birthMonth = celebratingFounder.birthday.split('-')[0];
  const birthDay = celebratingFounder.birthday.split('-')[1];
  const formattedBirthDate = `${birthYear}-${birthMonth}-${birthDay}`;
  
  // 计算年龄
  const age = currentYear - parseInt(birthYear);

  return (
    <div className="birthday-celebration-container">
      <div className="birthday-message">
        <button className="birthday-close-btn" onClick={handleClose} aria-label="关闭">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <div className="birthday-title">生日祝福 Birthday Wishes</div>
        <div className="birthday-image">
          <img src="/images/becetur.png" alt="生日祝福" />
        </div>
        <div className="birthday-subtitle">祝 <strong>{celebratingFounder.fullName}</strong> 生日快乐！</div>
        <div className="birthday-date-range">{formattedBirthDate} ~ {formattedCurrentDate} ({age} 岁生日)</div>
        <div className="birthday-buttons">
          <button 
            className="birthday-wish-btn" 
            onClick={handleWish}
            disabled={hasWished}
          >
            <svg className="birthday-wish-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M12,6C13.11,6 14,5.1 14,4C14,3.62 13.9,3.27 13.71,2.97L12,0L10.29,2.97C10.1,3.27 10,3.62 10,4C10,5.1 10.9,6 12,6M16.6,16L15.53,14.92L14.45,16C13.15,17.29 10.87,17.3 9.56,16L8.5,14.92L7.4,16C6.75,16.64 5.88,17 4.96,17C4.23,17 3.56,16.77 3,16.39V21C3,21.55 3.45,22 4,22H20C20.55,22 21,21.55 21,21V16.39C20.44,16.77 19.77,17 19.04,17C18.12,17 17.25,16.64 16.6,16M18,9H13V7H11V9H6C4.34,9 3,10.34 3,12V13.54C3,14.62 3.88,15.5 4.96,15.5C5.5,15.5 6,15.3 6.34,14.93L8.5,12.8L10.61,14.93C11.35,15.67 12.64,15.67 13.38,14.93L15.5,12.8L17.65,14.93C18,15.3 18.5,15.5 19.03,15.5C20.11,15.5 21,14.62 21,13.54V12C21,10.34 19.66,9 18,9Z" />
            </svg>
            {hasWished ? '已送出祝福' : '送出祝福'}
          </button>
          
          <div className="gift-dropdown-container" ref={dropdownRef}>
            <button 
              className="birthday-gift-btn" 
              onClick={toggleGiftDropdown}
            >
              <svg className="birthday-gift-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M22,12V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V12A1,1 0 0,1 1,11V8A2,2 0 0,1 3,6H6.17C6.06,5.69 6,5.35 6,5A3,3 0 0,1 9,2C10,2 10.88,2.5 11.43,3.24V3.23L12,4L12.57,3.23V3.24C13.12,2.5 14,2 15,2A3,3 0 0,1 18,5C18,5.35 17.94,5.69 17.83,6H21A2,2 0 0,1 23,8V11A1,1 0 0,1 22,12M4,20H11V12H4V20M20,20V12H13V20H20M9,4A1,1 0 0,0 8,5A1,1 0 0,0 9,6A1,1 0 0,0 10,5A1,1 0 0,0 9,4M15,4A1,1 0 0,0 14,5A1,1 0 0,0 15,6A1,1 0 0,0 16,5A1,1 0 0,0 15,4M3,8V10H11V8H3M13,8V10H21V8H13Z" />
              </svg>
              送出礼物
            </button>
            {isGiftDropdownOpen && (
              <div className="gift-dropdown">
                {giftOptions.map((option) => (
                  <div 
                    key={option.value} 
                    className="gift-dropdown-item"
                    onClick={() => handleSendGift(option.value)}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="danmaku-input-container">
          <input 
            type="text" 
            className="danmaku-input" 
            placeholder={isSendingCooldown ? "冷却中，请稍后..." : "输入你的祝福..."} 
            value={customMessage}
            onChange={(e) => setCustomMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            maxLength={30}
            disabled={isSendingCooldown}
          />
          <button 
            className="danmaku-send-btn" 
            onClick={handleSendCustomMessage}
            disabled={!customMessage.trim() || isSendingCooldown}
          >
            <svg className="danmaku-send-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M2,21L23,12L2,3V10L17,12L2,14V21Z" />
            </svg>
            {isSendingCooldown ? `发送 (${cooldownSeconds})` : '发送'}
          </button>
        </div>
      </div>
      
      {/* 显示漂浮弹幕 */}
      {danmakus.map(danmaku => (
        <div 
          key={danmaku.id} 
          className={`floating-danmaku ${danmaku.isUser ? 'user-danmaku' : ''}`}
          style={{ top: `${danmaku.position}%` }}
        >
          {danmaku.giftAmount ? (
            <><span>我</span> 送出了 <span className="gift-amount">{danmaku.giftAmount}</span> 个海龟币</>
          ) : danmaku.isCustom ? (
            <><span>我:</span> {danmaku.name}</>
          ) : (
            <><span>{danmaku.name}</span> 送出祝福</>
          )}
        </div>
      ))}
    </div>
  );
};

export default BirthdayCelebration;